import { AppRoutes as SharedAppRoutes } from '@cfra-nextgen-frontend/shared/src/routes/AppRoutes';
import { RouteType } from '@cfra-nextgen-frontend/shared/src/routes/types';
import { setUpAwsAmplifyRememberMeListener } from '@cfra-nextgen-frontend/shared/src/routes/utils';
import { ApplicationType } from '@cfra-nextgen-frontend/shared/src/utils/enums';
//import { Page } from 'analytics/Page';
import { exportSSRAgGrid } from 'components/excelExport/export';
import { sendMultipleRequest } from 'components/screener/api/screener';
import { getDataSource, getSsrDataExportFn } from 'components/screener/ssr';
import { Login } from 'features/auth/components/Login';
import { HomeRoutes } from 'features/home';
import { ResearchHubRoutes } from 'features/researchHub';
import { SnackbarProvider } from 'notistack';
import { useEffect, useRef } from 'react';
import { AuthenticatedRoutesWrapper } from 'routes/AuthenticatedRoutesWrapper';
import { getData, sendSingleInfiniteRequest, sendSingleRequest } from 'utils/api';
//import { PageNames, PageNamesToRoutePaths } from 'utils/enums';
//import { useUserPreferencesProps } from 'utils/preferences';

const routes: Array<RouteType> = [
    { path: '/research-hub/*', element: <ResearchHubRoutes /> },
    { path: '*', element: <HomeRoutes /> }
];

const unauthenticatedRoutes: {
    path: string;
    element: JSX.Element;
}[] = [];

// const userContextProviderProps = {
//     preferencesFetcherProps: {
//         ...useUserPreferencesProps,
//         updatePreferencesQueryConfig: { cacheTime: 500 },
//     },
// };

export function AppRoutes() {
    const rememberMe = useRef<boolean>();

    useEffect(() => {
        setUpAwsAmplifyRememberMeListener(rememberMe);
    }, []);

    return (
        <SharedAppRoutes
            loginElement={
                //<Page name={SharedPageNames.Login}>
                    <SnackbarProvider classes={{ containerRoot: 'cfra-snackbar-root' }}>
                        <Login rememberMe={rememberMe} />
                    </SnackbarProvider>
                //</Page>
            }
            unauthenticatedRoutes={unauthenticatedRoutes}
            authenticatedRoutesJsxGetterProps={{
                authenticatedRoutesWrapperJsx: <AuthenticatedRoutesWrapper />,
                projectSpecificResources: {
                    sendSingleRequest,
                    sendMultipleRequest,
                    sendSingleInfiniteRequest,
                    getDataSource,
                    getSsrDataExportFn,
                    exportSSRAgGrid,
                    getData,
                },
                routes,
            }}
            //userContextProviderProps={userContextProviderProps}
            applicationType={ApplicationType.WealthPortal}
        />
    );
}
